<div #trigger class="relative w-fit" (mouseenter)="show()" (mouseleave)="hide()" (click)="toggle()">
  <ng-content />
</div>

<ng-template #tooltipTpl>
  <div class="w-[362px] rounded bg-cp-primary-100 text-white p-2 text-xs shadow-lg">
    <p class="font-bold leading-[17px] mb-2">{{ heading() }}</p>

    <p class="leading-[17px] mb-2 text-white/60">
      So funktioniert die Bewertung – je mehr Sterne = größerer Leistungsumfang.
    </p>

    <div class="flex gap-2.5 text-white/60 leading-[17px]">
      <div class="shrink-0 whitespace-nowrap">
        ★★★<br />
        ★★★★<br />
        ★★★★★
      </div>
      <div>
        <p class="mb-0">Grundschutz – beinhaltet die wichtigsten Leistungen</p>
        <p class="mb-0">Guter Schutz – mit einigen Leistungserweiterungen</p>
        <p class="mb-0">
          5 Sterne: Sehr guter Schutz – mit besonders vielen Leistungserweiterungen
        </p>
      </div>
    </div>
  </div>
</ng-template>
